import { shadows } from "config/styles/shadows";

const styles = {
  contentWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    p: "20px 0",
  },
  orderWrap: {
    display: "flex",
    flexDirection: {
      xs: "column",
      md: "row",
    },
    justifyContent: "space-between",
    p: "16px",
    borderRadius: "10px",
    boxShadow: {
      xs: shadows.main,
    },
  },
  stepper: {
    maxHeight: "unset",
    overflowY: "unset",
    "& .MuiSvgIcon-root": {
      width: "16px",
      height: "16px",
    },
    "& .MuiStepConnector-root": {
      ml: "8px",
    },
    "& .MuiStepConnector-line": {
      minHeight: "10px",
    },
  },
  time: {
    color: "text.secondary",
    mt: "10px",
    ml: "24px",
    letterSpacing: "1px",
  },
  price: {
    ml: "24px",
    color: "text.primary",
    fontWeight: "bold",
    fontFamily: "sans-serif",
    letterSpacing: "1px",
  },
  status: {
    width: "fit-content",
    p: "4px 8px",
    borderRadius: "25px",
    backgroundColor: "gray.disabled",
    color: "background.default",
    textAlign: "center",
  },
  buttonsWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "14px",
    p: "8px 0",
  },
  btn: {
    minWidth: "230px",
    height: "36px",
  },
};

export default styles;
